<!--推荐配置Ec-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">励销推送配置</div>
    <el-tabs class="tabs-container" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="励销账号配置" name="first">
        <EcAccount></EcAccount>
      </el-tab-pane>
      <el-tab-pane label="来源配置" name="second" lazy=’true’>
        <EcOrigin :origin="origin"></EcOrigin>
      </el-tab-pane>
      <el-tab-pane label="字段配置" name="third" lazy=’true’>
        <EcField :origin="origin"></EcField>
      </el-tab-pane>
      <el-tab-pane label="资源分发规则" name="fourth" lazy=’true’>
        <EcRule :origin="origin"></EcRule>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import EcAccount from '@/components/client/lxcrm/LxcrmAccount'
  import EcOrigin from '@/components/client/crm/EcOrigin'
  import EcField from '@/components/client/crm/EcField'
  import EcRule from '@/components/client/crm/EcRule'
  export default {
    components: {
      EcAccount,
      EcOrigin,
      EcField,
      EcRule
    },
    data () {
      return {
        activeName: 'first',
        origin: 'lixiao'
      }
    }
  }
</script>
<style lang="scss">
.com-table .el-tabs__nav-wrap:after{
  height:1px;
}
</style>
<style scoped lang="scss">
@import '../../../assets/styles/_env.scss';

/deep/ .tabs-container {
  [aria-controls=pane-fourth] {
    color: $color-gray;
  }
  [aria-controls=pane-fourth]:hover,  [aria-controls=pane-fourth].is-active{
    color: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/lxcrm/LxcrmSetting.vue